export default __webpack_public_path__ + "static/media/checked-w.85ed3b9f.svg";